<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6">
          <h4 class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Detalle venta</h4>
        </div>
        <div class="col-sm-6 form__head__boxBtn">
          <button type="button" class="btn btn-secondary btn-sm waves-effect" (click)="cancel()"><i
              class="fas fa-arrow-left m-r-5"></i>
            Regresar
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12" *ngIf="sale != null">
    <div class="card m-b-30 m-b-50">
      <div class="card-body faq-box"
        [ngClass]="{'border-danger':sale.deleted_at != null, 'border-warning':sale.status_paid.class=='warning', 'border-primary':sale.status_paid.class=='primary'}">
        <div class="row">
          <div class="form-group col-lg-3">
            <label>N° venta</label>
            <p class="m-0 bold">{{sale.code}}</p>
          </div>
          <div class="form-group col-lg-3">
            <label>Tipo</label>
            <p class="m-0">
              <span *ngIf="sale.bookinghotel_id == null">Directa</span>
              <span class="badge badge-checkin f-s-12" *ngIf="sale.bookinghotel_id != null">Book Hotel</span>
            </p>
          </div>
          <div class="form-group col-lg-3">
            <label>Fecha y hora</label>
            <p class="m-0">{{sale.date_sale}}</p>
          </div>
          <div class="form-group col-lg-3">
            <label>Transacción</label>
            <p class="m-0">
              <span *ngIf="sale.typetransaction_id == 1">CONTADO</span>
              <span *ngIf="sale.typetransaction_id == 2">CRÉDITO</span>
            </p>
          </div>
          <div class="form-group col-lg-3">
            <label>TOTAL VENTA</label>
            <p class="m-0">
              {{sale.total | currency:'S/. '}}
            </p>
          </div>

          <div class="form-group col-lg-6">
            <label><i class="fas fa-user-alt m-r-5"></i>Datos del cliente</label>
            <p class="m-b-0">{{sale.client_data.fullname}}</p>
            <p class="light f-s-11 m-b-0">{{sale.client_data.typeDocument}} : {{sale.client_data.document}}</p>
          </div>
          <div class="form-group col-lg-3">
            <label>Estado</label>
            <span *ngIf="sale.deleted_at != null" class="badge badge-danger f-s-11">Anulado</span>
            <span *ngIf="sale.deleted_at == null"
              class="badge f-s-11 badge-{{sale.status_paid.class}}">{{sale.status_paid.message}}</span>
          </div>
          <!-- <div class="form-group col-lg-12" *ngIf="sale.deleted_at == null">
            <span class="badge badge-secondary f-s-12"><i class="fas fa-info-circle m-r-5"></i> Para eliminar o rehacer
              la venta, deberá anular los comprobantes asociados a ésta. <i class="fas fa-arrow-down m-l-5"></i></span>
          </div> -->
        </div>
      </div>
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="tab" href="#product" role="tab" aria-selected="true">
            <span class="d-none d-md-block bold">Productos</span><span class="d-block d-md-none"><i
                class="mdi mdi-home-variant h5"></i></span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div class="tab-pane p-3 active" id="product" role="tabpanel">
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Código</th>
                  <th>Nombre producto</th>
                  <th class="w-15 text-center">U. Medida</th>
                  <th class="w-15 text-right">Cantidad</th>
                  <th class="w-15 text-right">Precio compra</th>
                  <th class="w-15 text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="detail.length == 0">
                  <tr>
                    <td colspan="6"><span>No se encontraron registros</span></td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="detail.length > 0">
                  <tr *ngFor="let item of detail; let index_ = index">
                    <td>{{item.code}}</td>
                    <td>{{item.description}}</td>
                    <td class="w-15 text-center">{{item.unitmeasure}}</td>
                    <td class="w-15 text-right">{{item.quantity}}</td>
                    <td class="w-15 text-right">{{item.price}}</td>
                    <td class="w-15 text-right">
                      <span class="bold">{{item.subtotal | currency:'S/.'}}</span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-lg-12 form__detail__zonedivider" *ngIf="sale.bookinghotel_id == null">
        <p class="form__detail__grouptitle"><i class="fas fa-money-bill-alt m-r-5"></i>Comprobantes y cobros realizados
        </p>
        <div class="table-responsive">
          <table class="table table-sm mb-0">
            <thead class="thead-default">
              <tr>
                <th>Tipo comprobante</th>
                <th>N° comprobante</th>
                <th class="text-center">Fecha</th>
                <th class="w-15 text-center">Método pago</th>
                <th class="w-15 text-right">Pagado</th>
                <th class="w-15 text-center"></th>
                <!-- <th class="text-center"></th> -->
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="movements.length > 0">
                <tr *ngFor="let item of movements; let index_ = index">
                  <td>{{item.typevoucher}}</td>
                  <td>{{item.nro_voucher}}</td>
                  <td class="text-center">{{item.date_movement |  date: 'YYYY-MM-dd'}}</td>
                  <td class="w-15 text-center">{{item.paymethod}}</td>
                  <td class="w-15 text-right">{{item.total_amount | currency:'S/.'}}</td>
                  <td class="w-15 text-center">
                    <div *ngIf="item.date_repayment == null">
                      <a title="{{item.typevoucher}}" class="text-warning pointer bold" target="_blank"
                        href="/{{branchofficeSlug}}/api/print/billing/document/{{item.id}}"
                        *ngIf="item.voucher_id == typevoucher_factura.id || item.voucher_id == typevoucher_boleta.id || item.voucher_id == typevoucher_ordernote.id">
                        <i class="fas fa-print f-s-16"></i>
                      </a>
                      <a title="{{item.typevoucher}}" class="text-warning pointer bold" target="_blank"
                        href="/{{branchofficeSlug}}/api/print/income/document/{{sale.id}}"
                        *ngIf="item.voucher_id == typevoucher_income.id || item.voucher_id == typevoucher_expense.id">
                        <i class="fas fa-print f-s-16"></i>
                      </a>
                    </div>
                    <div *ngIf="item.date_repayment != null">
                      <span class="badge badge-danger f-s-11">Anulado</span>
                    </div>
                  </td>
                  <!-- <td class="text-center">
                    <button class="btn btn-sm btn-info" ng-click="goToMoneyMovement(item)">Ir a movimiento <i
                        class="m-r-2 fas fa-arrow-right"></i></button>
                  </td> -->
                </tr>
              </ng-container>

            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
